import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import { IconComponent, If } from '..'

import './CamPermissionsPromptComponent.scss'

const CamPermissionsPromptComponent = ({ productName, showMuteNotice }) => {
  return (
    <div className="cam-permissions-prompt-component">
      <div className="preview-box">
        <IconComponent name="camera-off" size={[24, 24]} color="aaa" />
        <FormattedMessage defaultMessage="Camera/microphone not active" />
      </div>
      <div className="body">
        <h3>
          <FormattedMessage
            defaultMessage="To use {productName} we need to get access to your camera and microphone"
            values={{ productName }}
          />
        </h3>
        <h4>
          <FormattedMessage defaultMessage='Please click "allow" on the pop-up in the top left corner of your browser.' />
        </h4>
        <If condition={showMuteNotice}>
          <p className="permission-notice">
            <FormattedMessage defaultMessage="You can mute your microphone any time inside the room" />
          </p>
        </If>
      </div>
    </div>
  )
}

CamPermissionsPromptComponent.propTypes = {
  productName: PropTypes.string.isRequired,
  showMuteNotice: PropTypes.bool,
}

CamPermissionsPromptComponent.defaultProps = {
  showMuteNotice: false,
}

export default CamPermissionsPromptComponent
